class ProductBundles extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    if (!this.els?.product_replacer?.exists) return

    this.els.product_replacer.elements.forEach((product_replacer) => {
      product_replacer.addEventListener('click', this.onReplacerClick.bind(this))
    })
  }

  onReplacerClick (e) {
    const currentTarget = e.currentTarget

    const radio = currentTarget.querySelector('[data-radio]')
    radio.checked = true

    const inputValue = document.querySelector(`[data-product-bundles-external-el="${this.dataset.id}"]`)
    inputValue.value = radio.value

    const title = currentTarget.querySelector('[data-title]')
    this.els.title.elements.forEach((titleEl) => {
      titleEl.innerHTML = title.innerHTML
    })

    const media = currentTarget.querySelector('[data-media]')
    this.els.media.element.innerHTML = media.innerHTML

    const url = currentTarget.querySelector('[data-url]')
    this.els.url.elements.forEach((urlEl) => {
      urlEl.href = url.href
    })

    const price = currentTarget.querySelector('[data-price]')
    this.els.price.element.innerHTML = price.innerHTML


    this.updatePrice()
  }

  updatePrice () {
    if (!this.externalEls?.original_price?.element || !this.externalEls?.bundle_price?.element) return

    const originalPrices = document.querySelectorAll('[data-product-bundles-el="price"] [data-original-price]')
    let originalPricesTotal = 0
    originalPrices.forEach(({ dataset: { price } }) => {
      originalPricesTotal += parseFloat(price)
    })

    const bundlePrices = document.querySelectorAll('[data-product-bundles-el="price"] [data-bundle-price]')
    let bundlePricesTotal = 0
    bundlePrices.forEach(({ dataset: { price } }) => {
      bundlePricesTotal += parseFloat(price)
    })

    this.externalEls.original_price.element.innerHTML = window.BAO.Utils.formatMoney(originalPricesTotal)
    this.externalEls.bundle_price.element.innerHTML = window.BAO.Utils.formatMoney(bundlePricesTotal)
  }
}

if (!customElements.get('product-bundles')) {
  customElements.define('product-bundles', ProductBundles)
}

class ProductBundlesForm extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.els.submit.element.addEventListener('click', this.addToCart.bind(this))
  }

  async addToCart () {
    const cartState = await this.getCartState()
    const itemsToAdd = []

    const baseProductId = parseInt(this.els.base_product_id.element.value)
    const bundleProduct1Id = parseInt(this.els.bundle_product_1_id.element.value)
    const bundleProduct2El = this.els.bundle_product_2_id?.element
    const bundleProduct2Id = bundleProduct2El ? parseInt(bundleProduct2El.value) : null

    if (!this.isProductInCart(cartState, bundleProduct1Id)) {
      itemsToAdd.push({ id: bundleProduct1Id, quantity: 1, properties: { '_Bundle Item': true }})
    }

    if (bundleProduct2Id && !this.isProductInCart(cartState, bundleProduct2Id)) {
      itemsToAdd.push({ id: bundleProduct2Id, quantity: 1, properties: { '_Bundle Item': true }})
    }

    if (!this.isProductInCart(cartState, baseProductId)) {
      itemsToAdd.push({ id: baseProductId, quantity: 1 })
    }

    if (itemsToAdd.length) {
      try {
        const newState = await window.BAO.Cart.addItem(itemsToAdd, {
          sections: window.BAO.sectionRenderer.pushCartSections.map(s => s.section),
        })
      } catch (error) {
        console.error('Error adding items to cart:', error)
      }
    } else {
      document.querySelector('[data-drawers-trigger="cart"]').click()
    }
  }

  async getCartState() {
    try {
      const response = await fetch('/cart.js')
      const cartState = await response.json()
      return cartState
    } catch (error) {
      console.error('Error fetching cart state:', error)
    }
  }

  isProductInCart(cartState, productId) {
    return cartState.items.some(item => item.id === productId)
  }
}

if (!customElements.get('product-bundles-form')) {
  customElements.define('product-bundles-form', ProductBundlesForm)
}
